import { useNavigate } from 'react-router-dom';

export default function ThankYouPage() {
  const navigate = useNavigate();

  const containerStyle = {
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2rem',
  };

  const titleStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#bf2121', 
    marginBottom: '1rem',
  };

  const textStyle = {
    maxWidth: '600px',
    color: '#4a5568', 
    marginBottom: '2rem',
  };

  const buttonStyle = {
    backgroundColor: '#bf2121',
    color: '#ffffff',
    padding: '0.75rem 1.5rem',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'background-color 0.2s ease-in-out',
  };

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = '#bf2121'; 
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = '#2f855a';
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Hvala vam na popunjavanju upitnika!</h1>
      <p style={textStyle}>
        Vaši odgovori su uspješno zabilježeni. Vaše učešće je važno za transparentnost i razvoj lokalne zajednice.
      </p>
      <button
        style={buttonStyle}
        onClick={() => navigate('/welcome')}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        Vrati se na početnu
      </button>
    </div>
  );
}
